<template>
  <div>
    <el-menu style="displat:none" mode="horizontal" class="head-el-menu" :default-active="onRoutes" :default-openeds="onSubMenus"
      text-color="#000000" :active-text-color="activeTextColor" unique-opened @select="openSubMenu">
      <template v-for="menu in parMenus">
        <el-menu-item :index="menu.resourcename" :route="menu.resourcename">
          &nbsp;
          <i :class="getMenuIcon(menu.icon)"></i>
          <span>&nbsp;{{menu.resourceinfo}}</span>
          &nbsp;
        </el-menu-item>
      </template>
    </el-menu>
    <AsideDom width="240px"></AsideDom>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
//引入Aside Component
import AsideDom from '@/views/common/layout/AsideDom'
export default {
  name: "MenuDom",
  components: {
    AsideDom
  },
  data() {
    return {
      activeTextColor: '#3baaff',
      isUniqueOpened: true,
      parMenus: [],
      subMenus: [],
      tzggMenus: [],
      tzggActive:''
    };
  },
  beforeCreate() {
    //初始化菜单
    let vm = this;
    vm.$axios.get("/resource/menuTree").then(function(res) {
      let menus = []
      res.data.result.forEach(e => {
          menus.push(e)
      })
      vm.parMenus = menus;
      vm.subMenus = res.data.result[0].children;
    }.bind(this),function(error) {
        console.log(error);
      }
    );
  },
  methods: {
    //获取菜单图标
    getMenuIcon(value) {
      return "iconfont " + value;
    },

    //打开子菜单
    openSubMenu(index, indexPath) {
      for(var i in this.parMenus) {
        if(index == this.parMenus[i].resourcename) {
          this.subMenus = this.parMenus[i].children;
          break;
        }
      }
      if(this.subMenus == null || this.subMenus.length == 0){
        this.$router.push({ path: index });
      }else{
        if(this.subMenus[0].children == null){
          this.$router.push({ path: this.subMenus[0].resourcename });
        }else{
          this.$router.push({ path: this.subMenus[0].children[0].resourcename });
        }
      }
    },
  },

  computed: {
    onRoutes() {
      var routePath = this.$route.path;
      if(this.$route.matched.length > 3){
        routePath = this.$route.matched[2].path;
      }else if(this.$route.matched.length == 3 && !this.$route.matched[2].path.endsWith('/')){
        routePath = this.$route.matched[1].path;
      }
      if(routePath.endsWith('/')){
        routePath = routePath.substr(0, routePath.length-1);
      }
      for(var i in this.parMenus){
        if(routePath == this.parMenus[i].resourcename){
          this.subMenus = this.parMenus[i].children;
          return routePath;
        }else{
          if(this.parMenus[i].children != null){
            for(var j in this.parMenus[i].children){
              if(routePath == this.parMenus[i].children[j].resourcename){
                this.subMenus = this.parMenus[i].children;
                return this.parMenus[i].resourcename;
              }else{
                if(this.parMenus[i].children[j].children != null){
                  for(var k in this.parMenus[i].children[j].children){
                    if(routePath == this.parMenus[i].children[j].children[k].resourcename){
                      this.subMenus = this.parMenus[i].children;
                      return this.parMenus[i].resourcename;
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    onSubMenus() {
      return this.subMenus;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../common/scss/mixin.scss";
.head-el-menu {
  height: 100%;
  // background-image: url("/static/images/login/head_bg.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: bottom;
  background-image: linear-gradient(50deg, #007cc0,#01276a);
  text-align: center;
}
.el-menu--horizontal>.el-menu-item {
  height: 40px;
  line-height: 40px;
  width: 12%;
  min-width: 180px;
  text-align: center;
  color: #fff !important;
  display: inline-block;
  float: none;
}
.el-menu-item i {
  font-size: 1rem;
  @include font-color($color-theme);
}
.el-submenu__title i {
  @include font-color($color-theme);
}
.el-menu-item.is-active{
  font-size: 1rem;
  font-weight: 600;
  border-bottom: 2px solid #FFCE32 !important;
  @include br-color($color-theme);
}
.el-menu-item *{
  font-size: 1rem;
}
.el-submenu__title:hover {
  background-color: rgba(214, 214, 215, 0.32) !important;
  color:#303133 !important;
}
.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,.el-menu--horizontal>.el-menu-item:not(.is-disabled):hover{
  background-color: transparent !important;
}
.head-el-menu{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/common/layout/MenuDom.vue